module.exports = require('preact-compat').createClass;



// WEBPACK FOOTER //
// ../node_modules/preact-compat/lib/create-react-class.js